import { getAppStore } from '@/store';
import { InputType } from '@/types';

import type { Preset, IInput, IImageInput, IVideoInput } from '@/types';

const buildInputsFromPreset = (preset: Preset): IInput[] => {
  const textItems = preset.textItems ?? [];
  const uploadItems = preset.uploadItems ?? [];

  const currentInputs = getAppStore().inputs;
  const previousImageSrc = currentInputs.find(
    (input): input is IImageInput =>
      input.type === InputType.IMAGE && !!input.src
  )?.src;
  const previousVideoSrc = currentInputs.find(
    (input): input is IVideoInput =>
      input.type === InputType.VIDEO && !!input.src
  )?.src;

  let usedImageSrc = false;
  let usedVideoSrc = false;

  const cleanedUploadItems = uploadItems.map((item) => {
    if (item.type === InputType.IMAGE && previousImageSrc && !usedImageSrc) {
      usedImageSrc = true;
      return { ...item, src: previousImageSrc };
    }
    if (item.type === InputType.VIDEO && previousVideoSrc && !usedVideoSrc) {
      usedVideoSrc = true;
      return { ...item, src: previousVideoSrc };
    }
    return { ...item, src: '' };
  }) as typeof uploadItems;

  return [...cleanedUploadItems, ...textItems];
};

export default buildInputsFromPreset;
